/*
 * @Description:
 * @Date: 2019-03-29 13:49:26
 */
import Vue from 'vue';
import dateFormat from '@/tools/dateFormat';
import { twoDecimal } from '@/tools/money';
import { recordStatus, questionType } from '@/config/staticData';

Vue.filter('transDate', function(val) {
  if (val) {
    return dateFormat(val, 'YYYY-MM-DD');
  }
  return '-';
});
Vue.filter('transMon', function(val) {
  if (val) {
    return dateFormat(val, 'YYYY-MM');
  }
  return '无';
});

Vue.filter('transMonth', function(input) {
  if (typeof input == 'number') {
    return dateFormat(input, 'MM月DD日 HH:mm');
  } else {
    return input;
  }
});
Vue.filter('transMinute', function(input) {
  if (typeof input == 'number') {
    return dateFormat(input, 'HH:mm:ss');
  } else {
    return input;
  }
});
Vue.filter('transAllTime', function(input, type = 'YYYY年MM月DD日 HH:mm:ss') {
  if (typeof input == 'number') {
    if (type === '-') {
      type = 'YYYY-MM-DD HH:mm:ss';
    }
    return dateFormat(input, type);
  } else {
    return '-';
  }
});
Vue.filter('transOpenStatus', function(val) {
  const obj = {
    0: '未开通',
    1: '开通中',
    2: '开通成功',
    3: '开通失败'
  };
  return obj[val] || '未开通';
});
Vue.filter('transCollectMoneyType', function(val) {
  const obj = {
    1: '银行卡',
    2: '钱包'
  };
  return obj[val] || '银行卡';
});
Vue.filter('transAllMin', function(input, type = 'YYYY-MM-DD HH:mm') {
  if (typeof input == 'number') {
    if (type === '-') {
      type = 'YYYY-MM-DD HH:mm';
    }
    return dateFormat(input, type);
  } else {
    return '-';
  }
});
//格式化 钱
Vue.filter('money', function(num) {
  const _num = twoDecimal(num, 100);
  return _num === '-' ? 0 : _num;
});

//格式化 钱
Vue.filter('moneyFixed', function(num) {
  const _num = twoDecimal(num, 100, '元');
  return _num === '-' ? 0 : _num;
});

Vue.filter('transPhone', function(v) {
  let tel = '' + v;
  let resp = tel.replace(tel.substring(3, 7), '****');
  return resp;
});

Vue.filter('projectStatusFil', function(v) {
  if (v == 1) {
    return '已启用';
  } else {
    return '未启用';
  }
});

Vue.filter('transContract', function(row) {
  if (row.signStatus == 0 || !row.signStatus) {
    return '无';
  } else if (row.signStatus == 2) {
    return '已完成';
  } else if (row.signStatus == 3) {
    return '签约失败';
  } else if (row.signStatus == 1) {
    if (row.firstStatus == 2) {
      return '待我签';
    } else {
      return '待他签';
    }
  }
});
Vue.filter('transCsoStatus', function(val) {
  let s = ['待支付', '支付中', '支付成功', '支付失败'];
  return s[val];
});
Vue.filter('transSignStatus', function(val) {
  let s = ['未签约', '签约中', '签约成功', '签约失败'];
  return s[val] || '-';
});
Vue.filter('transEContract', function(row) {
  if (row.lineType == 2) {
    return '线下签约';
  } else {
    if (row.signStatus == 0 || !row.signStatus) {
      return '无';
    } else if (row.signStatus == 2) {
      return '已完成';
    } else if (row.signStatus == 3) {
      return '签约失败';
    } else if (row.signStatus == 1) {
      if (row.firstStatus == 2) {
        return '待我签';
      } else {
        return '待他签';
      }
    }
  }
});
Vue.filter('checkIfSign', function(row) {
  if (
    row.csoStatus != 1 ||
    row.industryFinish != 1 ||
    row.firstStatus != 2 ||
    row.secondStatus == 2
  ) {
    return true;
  } else {
    return false;
  }
});
Vue.filter('transScale', function(num) {
  const _num = twoDecimal(num, 1, '%');
  return _num;
});
// 任务记录中任务状态
Vue.filter('transAuditStatus', function({ isOut, auditStatus }) {
  if (isOut) {
    return '已退出';
  } else {
    let statusObj = recordStatus[auditStatus - 1] || { label: '-', value: 0 };
    return statusObj.label;
  }
});
//显示自然数
Vue.filter('naturalNumber', function(number) {
  return /[0-9]+/.test(number + '') ? number + '' : '-';
});

Vue.filter('questionTypeLabelFil', function(val) {
  if (!val) return '';
  let { type, secondType, timeType } = val;
  secondType = secondType || timeType;
  if (typeof val === 'object') {
    if (questionType[type].children) {
      return (questionType[type].children[secondType] || { label: '' }).label;
    }
    return (questionType[type] || { label: '' }).label;
  }
  return (questionType[val] || { label: '' }).label;
});
